import { useBgTheme } from 'common/hooks/useBgTheme'

import { ContentBlock } from '../ContentBlock'
import Loading from '../Loading/Loading'

export const ChatScreenSkeleton = () => {
  useBgTheme('#ffffff')
  return (
    <ContentBlock>
      <Loading />
    </ContentBlock>
  )
}

export default ChatScreenSkeleton
